import M from 'materialize-css'

export function displayError (e) {
  if (e.response) {
    M.toast({html: e.response.data})
  } else {
    M.toast({html: e.message})
  }
  return true
}



// WEBPACK FOOTER //
// ./src/helpers/error.js